import axios from 'api';

export const getEvaluationFormData = async (params) => {
  return axios.get(`api/evaluation_form/question/?search=${params.search}&page=${params.pageIndex}&page_size=${params.pageSize}`);
};

export const getSopCategory = ({ all }) => {
  return axios.get(`api/sop/sop/?get_all=${all}`);
};

export const addQuestion = (params) => {
  return axios.post(`api/evaluation_form/question/`, params);
};

export const updateQuestion = (params) => {
  return axios.put(`api/evaluation_form/question/${params.id}/`, params);
};

export const deleteQuestion = (id)=>{
  return axios.delete(`api/evaluation_form/question/${id}`)
}
